module.exports = __webpack_public_path__ + "img/webnew-salon2-content-p1.d7e90b70.png";